export enum LAYOUT_COLOR_TYPES {
  LIGHTMODE = 'light',
  DARKMODE = 'dark',
}

export enum LAYOUT_TYPES {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum LAYOUT_MODE_TYPES {
  FLUIDMODE = 'fluid',
  DETACHEDMODE = 'detached',
}

export enum TOPBAR_COLOR_TYPES {
  LIGHT = 'light',
  DARK = 'dark',
  BRAND = 'brand',
}

export enum MENU_COLOR_TYPES {
  LIGHT = 'light',
  DARK = 'dark',
  BRAND = 'brand',
}

export enum SIDEBAR_SIZE_TYPES {
  DEFAULT = 'default',
  COMPACT = 'compact',
  CONDENSED = 'condensed',
  HIDDEN = 'fullscreen',
  HOVER = 'sm-hover',
  FULL = 'full',
  HOVER_ACTIVE = 'sm-hover-active',
}

